import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { photos } from '../../data/site';
import { usePrograms } from '../../contexts/ProgramContext';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
export function Community() {
  const {
    setActiveId
  } = usePrograms();
  return <section id="community" aria-labelledby="community-title" className="on-dark bg-coal py-20 text-white lg:py-28" data-id="element-36" data-mp="qw9t6q0cu6cl">
      <Container className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-37" data-mp="vuusmn7s8lzz">
        <div className="lg:col-span-7" data-id="element-38" data-mp="10wtxk1j67qz1">
          <img src={photos.medal} alt="A Bates Taekwondo student celebrating with a medal" className="aspect-[4/3] w-full rounded object-cover lg:aspect-[3/2]" style={{
          objectPosition: '50% 30%'
        }} loading="lazy" data-id="element-39" data-mp="10to8gmajkp3b" />
        </div>

        <Reveal className="lg:col-span-5" data-id="element-40" data-mp="36qabz9o8ytdq">
          <SectionTitle id="community-title" data-id="element-41" data-mp="3ntkm3tzi4cot">Room to keep growing</SectionTitle>
          <p className="text-pretty mt-6 text-[1.05rem] leading-relaxed text-white/80" data-id="element-42" data-mp="3j22h8uucxryk">
            Some students discover they love to compete. Others train for skill, fitness and the friends they’ve made.
            Both belong at Bates.
          </p>

          <dl className="mt-8 divide-y divide-white/15 border-y border-white/15" data-id="element-43" data-mp="396971i442ajy">
            <div className="py-5" data-id="element-44" data-mp="amaduboy7ic0">
              <dt className="font-display text-xl font-semibold uppercase tracking-wide" data-id="element-45" data-mp="akg13kntywj0">General classes</dt>
              <dd className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-46" data-mp="omlttiq8oxj">
                Beginner-friendly training focused on technique, fitness and personal progress.
              </dd>
            </div>
            <div className="py-5" data-id="element-47" data-mp="2lell7elphpoj">
              <dt className="font-display text-xl font-semibold uppercase tracking-wide" data-id="element-48" data-mp="2lfmyzqu3wq9y">Competition Team</dt>
              <dd className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-49" data-mp="2ge7go6jbcxv9">
                An additional pathway for committed athletes, with coaching for tournament Taekwondo.
              </dd>
            </div>
          </dl>

          <ButtonLink href="#program-detail" variant="outlineLight" onClick={() => setActiveId('competition-team')} className="mt-8" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="13jbfy3nmg6an" />} data-id="element-50" data-mp="1cfkfrjfih6xb">
            About the Competition Team
          </ButtonLink>
        </Reveal>
      </Container>
    </section>;
}